export enum TaskActionTypes {
    FILE_DOWNLOAD = 'file-download',
    AUTOCOMPLETE = 'autocomplete',
}
